import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  FiGrid,
  FiFolder,
  FiCalendar,
  FiCheckSquare,
  FiMessageSquare,
  FiHelpCircle,
  FiLogOut,
} from "react-icons/fi";
import { RiRobot2Line } from "react-icons/ri";
import { auth } from "../../Auth/firebase";
import { signOut } from "firebase/auth";
import { useProjects } from "../../../context/ProjectsContext";
import logo from "../../../assets/logoTrans.png";

const MenuItem = ({ text, linkTo, isActive, dropdownItems, isDisabled }) => {
  const [showDropdown, setShowDropdown] = useState(false);

  const handleMouseEnter = () => {
    setShowDropdown(true);
  };

  const handleMouseLeave = () => {
    setShowDropdown(false);
  };

  return (
    <div className="relative">
      <Link
        to={isDisabled ? "#" : linkTo}
        className={`flex items-center w-full font-medium py-4 text-lg text-left focus:outline-none pl-4 rounded-l-2xl rounded-r-full mb-2 
          ${
            isActive
              ? "bg-[#8484f0] text-white"
              : "bg-white text-lg hover:bg-[#ff8080] hover:text-white"
          }
          ${isDisabled ? "cursor-not-allowed opacity-50" : ""}
        `}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <span className="mr-3">
          {text === "Dashboard" ? (
            <FiGrid />
          ) : text === "Projects" ? (
            <FiFolder />
          ) : text === "Calendar" ? (
            <FiCalendar />
          ) : text === "Tasks" ? (
            <FiCheckSquare />
          ) : text === "Communication" ? (
            <FiMessageSquare />
          ) : text === "Collab AI" ? (
            <RiRobot2Line />
          ) : text === "Help" ? (
            <FiHelpCircle />
          ) : text === "Logout" ? (
            <FiLogOut />
          ) : null}
        </span>
        {text}
      </Link>
      {text === "Communication" && (
        <div
          className={`absolute top-full left-0 w-full bg-white shadow-md rounded-b-md z-10 transition-opacity duration-300 ${
            showDropdown
              ? "opacity-100 pointer-events-auto"
              : "opacity-0 pointer-events-none"
          }`}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <ul className="rounded-b-md">
            {dropdownItems.map((item, index) => (
              <li key={index}>
                <Link
                  to={isDisabled ? "#" : item.link}
                  className={`flex items-center py-2 px-4 text-lg text-neutral-900 ${
                    isDisabled
                      ? "cursor-not-allowed opacity-50"
                      : "hover:bg-[#ff8080] hover:text-white"
                  }`}
                >
                  <span className="mr-3">
                    {item.name === "DMs" ? (
                      <FiMessageSquare />
                    ) : item.name === "Meetings" ? (
                      <FiCalendar />
                    ) : item.name === "Channels" ? (
                      <FiFolder />
                    ) : null}
                  </span>
                  {item.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

function Sidebar() {
  const location = useLocation();
  const { projects } = useProjects();
  const hasProjects = projects.length > 0;

  const menuItems = [
    { name: "Dashboard", link: "/" },
    { name: "Projects", link: "/projects" },
    { name: "Calendar", link: "/calendar" },
    { name: "Tasks", link: "/tasks" },
    {
      name: "Communication",
      dropdownItems: [
        { name: "DMs", link: "/communication/dms" },
        { name: "Meetings", link: "/communication/meetings" },
        { name: "Channels", link: "/communication/channels" },
      ],
    },
  ];

  const footerItems = [
    { name: "Collab AI", link: "/collabAI" },
    { name: "Help", link: "/help" },
    { name: "Logout", link: "/logout" },
  ];

  const handleLogout = () => {
    signOut(auth)
      .then(() => {
        console.log("User signed out");
      })
      .catch((error) => {
        console.error("Sign out error:", error);
      });
  };

  return (
    <div className="flex flex-col p-0 pr-[30px] bg-white text-neutral-900 w-1/6 h-screen">
      <div className="flex-1">
        <Link to="/" className="cursor-pointer">
          <img src={logo} alt="Logo" className="mb-4 mt-3 h-16" />
        </Link>
        <ul className="space-y-2 mt-10">
          {menuItems.map((item, index) => (
            <li key={index}>
              <MenuItem
                text={item.name}
                linkTo={item.link}
                isActive={location.pathname === item.link}
                dropdownItems={item.dropdownItems || []}
                isDisabled={
                  !hasProjects &&
                  item.name !== "Projects" &&
                  item.name !== "Dashboard"
                }
              />
            </li>
          ))}
        </ul>
      </div>
      <div>
        <hr className="border-t border-neutral-300 my-4" />
        <ul className="space-y-2">
          {footerItems.map((item, index) => (
            <li key={index}>
              {item.name === "Logout" ? (
                <Link
                  onClick={handleLogout}
                  className="flex items-center w-full font-medium py-4 text-left focus:outline-none pl-4 rounded-l-2xl rounded-r-full mb-2 bg-white text-lg hover:bg-[#ff8080] hover:text-white"
                >
                  <span className="mr-3">
                    <FiLogOut />
                  </span>
                  {item.name}
                </Link>
              ) : (
                <Link
                  to={item.link}
                  className="flex items-center w-full font-medium py-4 text-left focus:outline-none pl-4 rounded-l-2xl rounded-r-full mb-2 bg-white text-lg hover:bg-[#ff8080] hover:text-white"
                >
                  {item.name}
                </Link>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default Sidebar;
